<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title class="primary">
                        <v-toolbar-title style="color: white;">
                           Solicitar factura de reporte
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-icon color="white">mdi-file-document-multiple-outline</v-icon>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="12">
                                <v-card>
                                    <v-card-title> </v-card-title>
                                    <v-card-text>
                                        <v-data-table :headers="headers"
                                                      v-model="selected"
                                                      item-key="nrreporte"
                                                      :loading="show"
                                                      loading-text="Cargando... espere un momento"
                                                      no-data-text="No hay datos disponibles"
                                                      :single-select="singleSelect"
                                                      show-select
                                                      :search="search"
                                                      :items="reportes"
                                                      :footer-props="{
                                                  'items-per-page-options': [20, 50, 100],
                                                  'items-per-page-text':'Registros por página'
                                                }">
                                        </v-data-table>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="text-center">
                                <v-btn class="ma-2"
                                       color="primary"
                                       @click="Tramitar()">
                                    Continuar
                                    <template v-slot:loader>
                                        <span>Loading...</span>
                                    </template>
                                </v-btn>
                                <v-btn class="ma-2" @click="clearTabla()">
                                    Limpiar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mapActions, mapState } from 'vuex';
    import servicio from '@/services/TramitePago/TramitePago.Service.js';

    export default {
        title() {
            return this.$route.meta.title
        },
        data: () => ({
            headers: [
                { text: 'Reporte', value: 'nrreporte', class: "text title" },
                { text: 'Asistencia', value: 'Asistencia', class: "text title" },
                { text: 'Abogado', value: 'Abogado', class: "text title" },
                { text: 'Cliente', value: 'Cliente', class: 'text title' },
                { text: 'Fecha del Reporte', value: 'svfhreporte', class: "text title" },
                { text: 'Fecha Conclusión', value: 'svfhconclusion', clas: "text title" },
            ],
            selected: [],
            show: true,
            singleSelect: false,
            search: '',
            reportes: [],
        }),
        computed: {
            ...mapState([
                "domain",
                "informationPage",
                "paginacion",
                "permission",
                "user"
            ]),
        },
        methods: {
            SolicitarFactura() {
                servicio.SolicitarFactura(this).then(data => {
                    if (!data[0].hasOwnProperty('success')) {
                        this.reportes = data;
                    }
                    else {
                        console.log(data[0]);
                    }
                    this.show = false;
                });
            },
            Tramitar() {
                if (this.selected.length > 0) {
                    this.$router.push({ name: `EnvioSolicitudFactura`, params: { selected: this.selected } });
                }
                else {
                    this.$swal({
                        position: 'center',
                        icon: 'warning',
                        title: 'Debe seleccionar al menos un reporte para su Trámite',
                        showConfirmButton: true,
                        confirmButtonText: 'Aceptar',
                        timer: 2000,
                    });
                }

            },
            clearTabla() {
                this.selected = [];
            },
        },
        mounted() {
            this.SolicitarFactura();
        }
    }
</script>